import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBookingMultipleWithoutBed({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.692 11.632a.75.75 0 01-.303.939l-.091.046-6.003 2.572a.75.75 0 01-.475.04l-.115-.04-6-2.57a.75.75 0 01.496-1.413l.096.034L8 13.683l5.707-2.445a.75.75 0 01.985.394zm0-3.5a.75.75 0 01-.303.939l-.091.046-6.003 2.572a.75.75 0 01-.475.04l-.115-.04-5.987-2.565a.75.75 0 01.494-1.413l.097.034L8 10.183l5.707-2.445a.75.75 0 01.985.394zM7.626.844a.95.95 0 01.748 0l6.493 2.783a.95.95 0 010 1.746L8.374 8.156a.95.95 0 01-.748 0L1.133 5.373a.95.95 0 010-1.746zM8 2.316L2.904 4.5 8 6.683 13.095 4.5 8 2.316z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBookingMultipleWithoutBed.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBookingMultipleWithoutBed.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBookingMultipleWithoutBed svgRef={ref} {...props} />
));
export default ForwardRef;
